import React, { useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import { createNomineeProofApi } from "designs/v1/pages/ModifyKyc/services";
import { jsonToFormData } from "utils";

const NomineeModificationProof = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
}) => {
  const initialValues = {
    type_of_identification: "",
    nominee_front_id_proof: "",
    nominee_back_id_proof: "",
  };

  const handleSubmit = async (value) => {
    setIsLoading(true);
    const payload = {
      request_type: stageScreen,
      ...value,
    };
    if (payload.type_of_identification === "PAN") {
      payload["nominee_back_id_proof"] = "";
    }
    payload["doc_name"] = localStorage.getItem("NomineeRequestNumber");
    try {
      const resp = await createNomineeProofApi(jsonToFormData(payload));
      console.log("resp", resp);
      setStep("NomineeModificationReview");
      setIsLoading(false);
    } catch (error) {
      console.log("err", error);
      const { data } = error.response || {};
      toast.error(data.message?.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Title title="Nominee Modification Request" />
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
              <Form>
                <div className="form-group my-2">
                  <label>Type of identification</label>
                  <Field
                    as="select"
                    name="type_of_identification"
                    className="form-select"
                  >
                    <option value="">Select</option>
                    <option value={"PAN"}>PAN</option>
                    <option value={"Aadhaar"}>Aadhaar</option>
                    <option value={"DrivingLicense"}>Driving License</option>
                    <option value={"Passport"}>Passport</option>
                    <option value={"VoterID"}>Voter ID</option>
                    <option value={"Other"}>Other</option>
                  </Field>
                </div>
                <div>
                  <label>Front image</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => {
                      let file = e.target.files[0];
                      if (!file) return;
                      console.log("file", file);
                      setFieldValue("nominee_front_id_proof", e.target.files[0]);
                    }}
                  />
                </div>
                {values.type_of_identification !== "PAN" && (
                  <div>
                    <label>Back image</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => {
                        let file = e.target.files[0];
                        if (!file) return;
                        console.log("file", file);
                        setFieldValue("nominee_back_id_proof", file);
                      }}
                    />
                  </div>
                )}
                <div className="row m-4">
                  <Button
                    title="Submit"
                    disabled={!isValid || !dirty || isSubmitting || isLoading}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default NomineeModificationProof;
